import { render, staticRenderFns } from "./JoinedPQPage.vue?vue&type=template&id=9b0d8042&"
import script from "./JoinedPQPage.vue?vue&type=script&lang=js&"
export * from "./JoinedPQPage.vue?vue&type=script&lang=js&"
import style0 from "./JoinedPQPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports